import { get } from '../index'

export default {
  get: (id) => get(`examples/${id}`)
}
